import React from "react";
import { Image } from "../../../components/Image";
import default_profile_image from "../../../assets/expert-images/profile.jpg";
import { useNavigate } from "react-router-dom";
import { formatDesignation } from "../../../utils/formatDesignation";

const ExpertCardComponent = ({ data }) => {
  const navigate = useNavigate();

  //handle individual expert details
  const handleExpertProfile = (expert_id) => {
    if (data.designation === "sales_representative") {
      navigate(`/experts/${btoa(expert_id)}`);
    } else {
      navigate(`/experts/all/${btoa(expert_id)}`);
    }
  };

  return (
    <div
      onClick={() => handleExpertProfile(data.user_id)}
      className="bg-gray flex-1 min-w-[270px] lg:max-w-[280px] flex flex-col items-center gap-3 p-1 rounded cursor-pointer shadow-custom transition-transform duration-300 ease-in-out hover:scale-[1.01]"
    >
      <Image
        src={
          data.profile_image.length !== 0
            ? data.profile_image[0].url
            : default_profile_image
        }
        className="w-full h-[250px] rounded"
      />
      <div className="flex flex-col text-center pt-2 pb-5">
        <h1 className="font-bold text-yellow-200 capitalize">{data.name}</h1>
        <p className="text-yellow-200">
          {data.designation
            ? formatDesignation(data.designation)
            : "Property Expert"}
        </p>
        <p className="text-yellow">{data.location ? data.location : ""}</p>
      </div>
    </div>
  );
};

export default ExpertCardComponent;
